import { observer } from "mobx-react-lite";
import React, { FC, useMemo, useState } from "react";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { loginStore } from "@/modules/login/store";
import Input from "@/pages/Setting/components/Input";
import { bindPhone, pwdSet } from "@/pages/Setting/api";
import { Toast } from "@/components/Toast";

const BindPhone: FC<any> = (props) => {
  const { onClose } = props;
  const lang = langStore.tgt;
  const {
    userState: { userInfo },
  } = loginStore;
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const submitState = useMemo(() => {
    return code.length === 6 && phone.length === 11;
  }, [code, phone]);
  const submit = async () => {
    try {
      await bindPhone({
        code: code,
        mobileNumber: phone,
      });
      await loginStore.getUserInfo();
      onClose && onClose();
      Toast({
        status: "success",
        title: "手机号绑定成功",
      });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={styles.contentRowWrapper} style={{ borderStyle: "none", flexFlow: "column" }}>
      <Input
        label="手机号"
        type="tel"
        placeholder="请输入用于接收短信验证码的手机号"
        value={phone}
        onChange={(value: string | number) => {
          setPhone(value as string);
        }}
      />
      <Input
        phoneOrEmail={phone}
        label="验证码"
        type="code"
        placeholder="请输入短信验证码"
        value={code}
        onChange={(value: string | number) => {
          setCode(value as string);
        }}
      />
      <button
        className={styles.submit}
        disabled={!submitState}
        onClick={async () => {
          await submit();
        }}
      >
        绑定
      </button>
    </div>
  );
};
export default observer(BindPhone);
